export default __webpack_public_path__ + "static/media/business.a6da7008.svg";